<p>dashboard-panel works!</p>
